import { Button, Typography, useMediaQuery } from "@mui/material"
import { useEffect, useState } from "react"

export function BioSettings({ onUpdate, bioText }) {
    const [newBio, setNewBio] = useState(bioText || "")
    const [isDisabled, setIsDisabled] = useState(true)
    const isMobile = useMediaQuery('(max-width:1050px)')

    const MAX_BIO_LEN = 50

    useEffect(() => {
        setIsDisabled(newBio === bioText)
    }, [newBio, bioText])

    const handleBioChange = (event) => {
        let newBio = event.target.value
        if (newBio.length <= MAX_BIO_LEN) {
            setNewBio(newBio)
        }
    }

    const handleBioSave = () => {
        onUpdate(newBio)
        setIsDisabled(true)
    }

    const styles = {
        label: {
            fontWeight: 500,
            fontFamily: "inherit",
            m: 0.5,
        },
        form: {
            display: 'flex',
            flexDirection: 'column',
            width: isMobile ? '100%' : '60%',
        },
        textarea: {
            resize: 'none',
            border: 'none',
            borderRadius: '10px',
            fontFamily: 'inherit',
            background: '#dedfde',
            padding: '.4rem',
            maxHeight: '400px',
        },
        button: {
            textTransform: 'none',
            alignSelf: 'end',
            m: '.32rem 0',
            cursor: isDisabled ? 'none' : 'auto',
            borderRadius: '40px',
            boxShadow: "2px 3px 0px #000",
            '&:disabled': { cursor: 'not-allowed' },
        },
    }

    return (
        <>
            <Typography variant="body1" component="p" sx={styles.label}>
                Bio
            </Typography>
            <form style={styles.form}>
                <section style={{
                    display: 'flex',
                    flexDirection: 'column',
                }}>
                    <textarea
                        value={newBio}
                        onChange={handleBioChange}
                        placeholder="the world's listening!"
                        maxLength={50}
                        style={styles.textarea}
                    />
                    <Typography
                        variant="caption"
                        style={{
                            margin: '.2rem',
                            alignSelf: 'end'
                        }}>
                        {newBio.length}/50
                    </Typography>
                </section>
                <Button
                    variant="contained"
                    type="button"
                    disabled={isDisabled}
                    onClick={handleBioSave}
                    sx={styles.button}
                >
                    Save
                </Button>
            </form>
        </>
    )
}
